import React from 'react'
import PageShell from './PageShell'

/** Full-height tool UI (Email, Files) — portal sidebar or admin embedded shell */
export default function SharedToolPage({ embedded = false, children }) {
  if (embedded) {
    return (
      <div className="admin-tool-shell admin-tool-shell-full">
        {children}
      </div>
    )
  }

  return (
    <PageShell fullBleed>
      <div className="portal-tool-shell admin-tool-shell-full">
        {children}
      </div>
    </PageShell>
  )
}
